import {NavLink} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Link from "@material-ui/core/Link";
import React, {useEffect} from "react";

const contractStatus = {
    'disabled': {badge: "bg-danger", text: "Нельзя заключить договор"},
    'enabled': {badge: "bg-primary", text: "Можно заключить договор"},
    'preparation': {badge: "bg-warning", text: "Модератор проверяет данные"},
    'verification': {badge: "bg-secondary", text: "Подтвердите договор"},
    'concluded': {badge: "bg-success", text: "Договор активен"},
    'preparationForClient': {badge: "bg-info", text: "Клиент отправил данные для договора"}
}


const ContractTableRow = ({contract}) => {

    let contractsErrors = {...contract.contract.condition}


    return (
        <div className="contract">
            {contract.contract.stage !== "disabled" &&
            <NavLink to={`/lk/contracts/${contract.id}`} className="contract-link"></NavLink>}
            <div className="contract__info">
                <h5 className="title m-0">{contract.name}
                    <span
                        className={`badge ms-1 ${contractStatus[contract.contract.stage].badge}`}>
                        {contractStatus[contract.contract.stage].text}
                    </span>
                </h5>
                <div className="id">
                    id: {contract.id}
                </div>

            </div>
            <span className="contract-address">{contract.address}</span>
            {contractsErrors && contract.contract.condition.length !== 0 &&
            <div className="contract__addition alert alert-danger">
                <FontAwesomeIcon icon="exclamation-triangle" className="me-2"/>
                Для заключения договора необходимо заполнить обязательные пункты:
                <ol className="m-0 ms-3">
                    {Object.keys(contractsErrors).map((item) => {

                            return <li key={item}><Link component={NavLink}
                                                        to={contractsErrors[item].link}>{contractsErrors[item].text}</Link>
                            </li>
                        }
                    )}

                </ol>
            </div>}


        </div>

    )
}

export default ContractTableRow